<template>
  <div class="video" :class="{expanded: isPlaying}">
    <youtube :video-id="videoId" player-width="100%" player-height="100%" @playing="playing" @buffering="playing" @ended="paused" @paused="paused" :class="'iframe-wrap'"></youtube>
  </div>
</template>

<script>
export default {
  name: 'youtube-video',
  props: ['videoId'],
  data () {
    return {
      isPlaying: false
    }
  },
  methods: {
    playing () {
      this.isPlaying = true
    },
    paused () {
      this.isPlaying = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../variables.scss';
.video {
  flex: 1;
  margin: 0;
  box-shadow: 0 0 0 2px $light-purple;
  &:not(:first-child):not(:last-child) {
    margin: 0 $standard-spacing;
  }
  h3 {
    margin-top: $standard-spacing;
    color: $font-white;
    text-align: left;
    font-weight: normal;
  }
  &:hover,
  &:focus {
  }
}

.iframe-wrap {
  position: relative;
  min-width: 200px;
  width: 100%;
  :first-child {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &:before{
    content: "";
    display: inline-block;
    padding-top: 55.75%; /* 16:9 */
  }
}

@media (max-width: 750px) {
  .iframe-wrap {
    margin: 0 auto;
  }
  .video:not(:first-child):not(:last-child) {
    margin: $standard-spacing5/2 0;
  }
}
</style>



// WEBPACK FOOTER //
// YoutubeVideo.vue?ae5c8874